<template>
  <div class="content-box">
    <el-card class="box-card top-card">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="车型 : ">

          <el-select v-model="formInline.vehicleTypeCode" size="mini" placeholder="请选择">
            <el-option
                v-for="item in optionData"
                :key="item.vehicleTypeCode"
                :label="item.vehicleTypeName"
                :value="item.vehicleTypeCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间 : ">
          <el-date-picker
              v-model="formInline.time"
              size="mini"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchTableData(1)" type="primary" size="mini">查询</el-button>
          <el-button @click="searchTableData(2)" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px;">
        <el-button @click="openDrawer(1)" size="mini">新 增</el-button>
        <el-button @click="openDrawer(2)" size="mini">修 改</el-button>
        <el-popconfirm
            style="padding: 10px"
            title="确定将选择数据删除？"
            @confirm="deleteItems"
        >
          <el-button :loading="deleteType" size="mini" slot="reference">删除</el-button>
        </el-popconfirm>
      </div>
      <el-table
          row-key="id"
          v-loading="tableLoadingType"
          class="tableListValue"
          :height="tableHeight"
          ref="table"
          :data="tableData"
          stripe
          style="width: 100%">
        <el-table-column
            :reserve-selection="true"
            align="center"
            type="selection"
            width="50">
        </el-table-column>
        <el-table-column label="序号" type="index" width="60" align="center">
          <template #default="scope">
            <span v-text="getIndex(scope.$index)"></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="vehicleTypeName"
            align="center"
            label="车型">
        </el-table-column>
        <el-table-column
            prop="creator"
            align="center"
            label="创建账号">
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="modifTime"
            align="center"
            label="修改时间">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!--    新增修改弹框-->
    <el-drawer
        :destroy-on-close="true"
        :show-close="false"
        :title="drawerTitle"
        :visible.sync="drawerType"
        direction="rtl"
        size="30%">
      <car-model-dialog :drawerForm="drawerForm" :dialogType="dialogType" @drawerClose="drawerClose"></car-model-dialog>
    </el-drawer>
  </div>
</template>

<script>
import CarModelDialog from './components/carModelDialog'
import {getDatavehicleTypePage, getDatavehicleTypeList, delDatavehicleTypes} from "../../common/carModelApi";

export default {
  name: "carModelAdministration",
  components: {
    CarModelDialog
  },
  data() {
    return {
      optionData: [],
      drawerType: false,
      tableLoadingType: false,
      drawerTitle: '',
      dialogType: 0,
      drawerForm: {},
      deleteType: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      formInline: {},
      tableHeight: 0,
      tableData: []
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 85
    })
    this.getDatavehicleTypePage()
    this.getDatavehicleTypeList()
  },
  methods: {
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    // 搜索重置
    searchTableData(type) {
      this.currentPage = 1
      this.pageSize = 10
      if (type === 2) {
        this.formInline = {}
      }
      this.getDatavehicleTypePage()
    },
    // 获取下拉列表
    async getDatavehicleTypeList() {
      try {
        const res = await getDatavehicleTypeList()
        if (res.code === 200) {
          this.optionData = res.data
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取列表
    async getDatavehicleTypePage() {
      this.tableLoadingType = true
      try {
        const param = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          vehicleTypeCode: this.formInline.vehicleTypeCode,
          startTime: this.formInline.time ? this.formInline.time[0] : null,
          endTime: this.formInline.time ? this.formInline.time[1] : null,
        }
        const res = await getDatavehicleTypePage(param)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          this.tableLoadingType = false
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    // 关闭弹框
    drawerClose() {
      this.getDatavehicleTypePage()
      this.getDatavehicleTypeList()
      this.$refs.table.clearSelection();
      this.drawerType = false
    },
    // 新增修改弹框
    async openDrawer(type) {
      this.dialogType = type
      if (type === 1) {
        this.drawerTitle = '新增车型'
        this.drawerForm = {}
        this.drawerType = true
      } else {
        const arr = this.$refs.table.selection;
        if (arr.length === 0) {
          this.$notify.error({
            title: '操作错误 !',
            message: '请选择数据后操作 !'
          })
          return
        }
        if (arr.length > 1) {
          this.$notify.error({
            title: '操作错误 !',
            message: '只可选择一条数据后操作 !'
          })
          return
        }this.drawerForm = JSON.parse(JSON.stringify(arr[0]))
        this.drawerTitle = '修改车型'
        this.drawerType = true
      }
    },
    // 删除列表数据
    async deleteItems() {
      const arr = this.$refs.table.selection;
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后删除 !'
        })
        return
      }
      if (arr.length > 1) {
        this.$notify.error({
          title: '操作错误 !',
          message: '只可选择一条数据删除 !'
        })
        return
      }
      try {
        const ids = []
        for (const el of arr.values()) {
          ids.push(el.id)
        }
        this.deleteType = true
        const res = await delDatavehicleTypes({ids})
        if (res.code === 200) {
          this.$notify.success({
            title: '成功提示',
            message: '数据删除成功'
          })
          this.$refs.table.clearSelection();
          this.deleteType = false
          this.getDatavehicleTypePage()
          this.getDatavehicleTypeList()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
          this.deleteType = false
        }
      } catch (e) {
        this.deleteType = false
        console.log(e)
      }
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getDatavehicleTypePage()
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.getDatavehicleTypePage()
    },
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}

.box-card {
  text-align: left;
  border-radius: 10px;
  height: 100%;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
